import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate } from "react-router-dom";
import { postData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { GeneralCoverageForm } from "./components/generalCoverageForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";


const AddGeneralCoverage = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const handleAddCoverage = async (coverageData) => {
    setCircleLoading(true);
    const payload = {      
      name: coverageData?.name,
      description: coverageData?.description,
      coverageTypeId: coverageData?.coverageType?.value,
      autoApply: coverageData?.autoApply,
      mandatory: coverageData?.mandatory,
      isActive: coverageData?.active,
      productId: coverageData?.productId?.value,
      policyTypeId: coverageData?.policyTypeId?.value   
    };
    
    try {
      const response = await postData("/reference/general/coverage", payload);
      if(response?.success){
        showSnackbar(response?.message,"success");
        navigate("/general-master/general-coverage");
      }
    } catch (error) {
      console.error("Error Submitting",error);
      showSnackbar(error?.response?.data?.message, "error");
    }
    finally{
      setCircleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/general-master/general-coverage")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Add Coverage details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Add Coverage details
                    here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <GeneralCoverageForm onsubmit={handleAddCoverage} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default AddGeneralCoverage;
